// All events (E look). One event in v1. Stat cards show only what the data knows (no wallet, no quality).
import { CaretRight, ChartPieSlice, ChatsCircle, Gauge, Wrench } from "@phosphor-icons/react";
import { Link } from "@tanstack/react-router";
import { Ic, useTick } from "@/components/bits";
import { EVENT } from "@/lib/fields";
import { clock, fmt } from "@/lib/format";
import { SENDER_BADGE, senderState } from "@/model/advice";
import { useApp } from "@/shell/appData";

export function AllEvents() {
  const { counts, cap, runs, next } = useApp();
  const now = useTick(30_000);
  const st = senderState(runs, cap, next.waiting, now, counts.people);
  return (
    <div className="page e-look">
      <div className="pghead">
        <div className="t">
          <h1>All events</h1>
          <p>One event so far. One WhatsApp number serves every event.</p>
        </div>
      </div>
      <div className="stats">
        <Link className="stat" to="/send">
          <span className="k">
            <Ic i={Gauge} />
            Daily cap · this number
          </span>
          <span className="v">
            {fmt(cap.used)}
            <small>/ {fmt(cap.cap)}</small>
          </span>
          <span className="s">
            {cap.used ? `Used by ${EVENT.name}${cap.freesAt ? ` · frees ${clock(cap.freesAt)}` : ""}` : "Free"}
          </span>
        </Link>
        <Link className="stat" to="/wa">
          <span className="k">
            <Ic i={ChartPieSlice} />
            Coverage
          </span>
          <span className="v" data-testid="stat-coverage">
            {counts.coveragePct}%
          </span>
          <span className="s">
            {fmt(counts.got)} of {fmt(counts.people)} people got it
          </span>
        </Link>
        <Link className="stat" to="/people" search={{ v: "attention", s: "waiting" }}>
          <span className="k">
            <Ic i={ChatsCircle} />
            Replies waiting
          </span>
          <span className="v">{fmt(counts.waiting)}</span>
          <span className="s">{counts.waiting ? "Reply within 24 hours" : "Everyone has an answer"}</span>
        </Link>
        <Link className="stat" to="/people" search={{ s: "fix" }}>
          <span className="k">
            <Ic i={Wrench} />
            Need a fix
          </span>
          <span className="v" style={counts.fix ? { color: "var(--destructive)" } : undefined}>
            {fmt(counts.fix)}
          </span>
          <span className="s">Invalid or failed numbers</span>
        </Link>
      </div>
      <div className="section">
        <div className="section-h">
          <span className="label">{EVENT.org}</span>
        </div>
        <div className="list">
          <div className="list-h">
            <span style={{ flex: 1.6 }}>Event</span>
            <span className="hide-sm" style={{ width: 150 }}>
              WhatsApp
            </span>
            <span className="hide-md" style={{ width: 80, textAlign: "right" }}>
              Fix
            </span>
            <span className="hide-md" style={{ width: 80, textAlign: "right" }}>
              Replies
            </span>
            <span style={{ width: 150, textAlign: "right" }}>Sender</span>
            <span className="hide-sm" style={{ width: 16 }} />
          </div>
          <Link className="row" to="/wa" data-testid="event-row">
            <div className="tx" style={{ flex: 1.6 }}>
              <b>{EVENT.name}</b>
              <span>
                {EVENT.dates} · {fmt(counts.registrations)} registrations · {fmt(counts.phones)} phones
              </span>
            </div>
            <div className="hide-sm" style={{ width: 150 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 4 }}>
                <span className="muted">Coverage</span>
                <span className="num" data-testid="row-coverage">
                  {counts.coveragePct}%
                </span>
              </div>
              <div className="meter">
                <i style={{ width: `${counts.coveragePct}%`, background: "var(--primary)" }} />
              </div>
            </div>
            <div className="hide-md num" style={{ width: 80, textAlign: "right", fontSize: 12.5 }}>
              {counts.fix}
              <div className="muted" style={{ fontSize: 11 }}>
                need a fix
              </div>
            </div>
            <div className="hide-md num" style={{ width: 80, textAlign: "right", fontSize: 12.5 }}>
              {counts.waiting}
              <div className="muted" style={{ fontSize: 11 }}>
                replies
              </div>
            </div>
            <div style={{ width: 150, display: "flex", justifyContent: "flex-end" }}>
              <span className="badge">
                <span className={`sdot ${SENDER_BADGE[st].cls}`} style={{ width: 6, height: 6, boxShadow: "none" }} />
                {SENDER_BADGE[st].label}
              </span>
            </div>
            <Ic i={CaretRight} className="chev hide-sm" />
          </Link>
        </div>
      </div>
    </div>
  );
}
